import { firestore, config } from '../database';
import environment from '../constants/environment';
import fetch from 'node-fetch'; // TODO: Remove when updating to Node 18+

require('es6-promise').polyfill();

const excludeAndSort = (hits, exclude) =>
  hits
    .filter(o => !exclude.includes(o.id)) // Filter out the explicitly excluded
    .filter(o => !!o.main_photo) // Filter out photo-less profiles
    // Todo - need to fix when migrate packages to new api
    //.filter(o => o.package_count > 0) // Filter out package-less profiles
    .sort(function() {
      return 0.5 - Math.random();
    })
    .slice(0, 3);

const formatFacetFilters = filters => {
  return Object.fromEntries(
    Object.entries(filters).filter(([_, value]) => value != 'all')
  );
};

const fetchSimilarVendors = async (filters, vendors) => {
  const endpoint = `${environment.apiURL}/v2/vendors?`;
  return new Promise(resolve => {
    fetch(
      `${endpoint}&${new URLSearchParams({
        ...formatFacetFilters(filters),
        limit: 50,
      })}`,
      {
        method: 'GET',
      }
    )
      .then(res => res.json())
      .then(res => {
        const { data } = res;

        return resolve(excludeAndSort(data, vendors));
      });
  });
};

const listSimilarVendors = async (vendorId, filters) => {
  const origResults = await fetchSimilarVendors(filters, [vendorId]);

  if (origResults.length >= 3) {
    return origResults;
  }

  const exclude = origResults.map(vendor => vendor.id);

  const broaderResults = await fetchSimilarVendors(
    {
      area_level_1: filters.area_level_1,
      type: filters.type,
    },
    [vendorId, ...exclude]
  );

  return [...origResults, ...broaderResults];
};

export default {
  fetchVendor: slug => async (dispatch, getState) => {
    console.log(`Start fetch /${slug} from ${config.databaseURL}`);
    return new Promise(resolve => {
      dispatch({
        type: 'FETCH_VENDOR_INITIATED',
        slug,
      });

      const endpoint = `${environment.apiURL}/v2/vendors/${slug}`;
      fetch(endpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          if (response.status != 200) {
            throw new Error(response.error);
          }
          return response.json();
        })
        .then(async vendor => {
          const similarVendors = await listSimilarVendors(vendor.id, {
            type: vendor.type,
            area_level_1: vendor.area_level_1,
            area_level_2: vendor.area_level_2,
          });

          dispatch({
            type: 'FETCH_VENDOR_COMPLETED',
            vendor,
            similarVendors,
          });

          return resolve(vendor);
        })
        .catch(error => {
          dispatch({
            type: 'FETCH_VENDOR_FAILED',
          });
        });
    });
  },
  sendEnquiry: ({ vendorId, formData }) => dispatch => {
    return new Promise((resolve, reject) => {
      const endpoint = `${environment.apiURL}/vendor/contact/${vendorId}`;
      dispatch({
        type: 'SEND_ENQUIRY_INITIATED',
      });
      return fetch(endpoint, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        body: JSON.stringify({
          ...formData,
          vendorId,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(res => {
          if (!res.ok) {
            throw new Error('HTTP status ' + res.status);
          }
          dispatch({
            type: 'SEND_ENQUIRY_COMPLETED',
          });
          return res.json();
        })
        .then(json => {
          return resolve(json);
        });
    });
  },
};
